(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'RegalWingsAirRequest',
	};

	var form_id         = 'regalwingsairrequest-',
	    total_travelers = 0;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var request_type_radio = $('.request-type-switch');
		var flight_type_select = $('.rw-flight-type-switch');
		var return_field       = $('.rw-return-date');
		var multi_city_fields  = $('.rw-multi-city-fields');

		// toggling flight type request quote / work with client
		request_type_radio.on('change', function onRequestTypeChange(event)
		{
			var request_type = $(this).val();

			switch (request_type) {
				case 'work_client':
					$('.request-concierge').removeClass('hidden');
					$('.request-quote').addClass('hidden');
				break;
				case 'request_quote':
				default:
					$('.request-concierge').addClass('hidden');
					$('.request-quote').removeClass('hidden');
				break;
			}
		});

		// toggling flight type oneway/roundtrip/multicity
		flight_type_select.on('change', function onFlightTypeChange(event)
		{
			var flight_type = $(this).val();

			switch (flight_type) {
				case 'oneway':
					return_field.addClass('hidden');
					multi_city_fields.addClass('hidden');
				break;
				case 'multicity':
					return_field.addClass('hidden');
					multi_city_fields.removeClass('hidden');
				break;
				case 'roundtrip':
				default:
					return_field.removeClass('hidden');
					multi_city_fields.addClass('hidden');
				break;
			}
		});

		$('#' + form_id + 'departure_date').on('dp.change', function populateDropoff(event)
		{
			var return_date = '';

			if ($('#' + form_id + 'return_date').val() !== '') {
				return_date = Date.parse($('#' + form_id + 'return_date').val());
			}

			if (
				event.date
				&& (
					return_date === '' ||
					return_date <= event.date
				)
			) {
				$('#' + form_id + 'return_date').data('DateTimePicker').date(event.date.add(1, 'days'));
			}
		});

		// add to total travelers
		$('#' + form_id + 'number_of_adults').on('change keyup', function onNumberOfTravelersChange(event)
		{
			calculateTotalTravelers();
		});

		$('#' + form_id + 'number_of_children').on('change keyup', function onNumberOfTravelersChange(event)
		{
			calculateTotalTravelers();
		});

		$('#' + form_id + 'number_of_infants').on('change keyup', function onNumberOfTravelersChange(event)
		{
			calculateTotalTravelers();
		});

		function calculateTotalTravelers() {
			var i;

			total_travelers = 0;
			total_travelers += parseInt($('#' + form_id + 'number_of_adults').val() || 0);
			total_travelers += parseInt($('#' + form_id + 'number_of_children').val() || 0);
			total_travelers += parseInt($('#' + form_id + 'number_of_infants').val() || 0);

			for (i = 1; i <= 20; i++) {
				$('#traveler-' + i).addClass('hidden');
			}

			for (i = 1; i <= total_travelers; i++) {
				$('#traveler-' + i).removeClass('hidden');
			}

			console.log(total_travelers);
		}
	};
}(jQuery, window.Adzuki || {}));
